// encryption.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {
  timer: number = 120; // Set timer to 2 minutes (120 seconds)
  interval: any;
    async encryptAadhaar(aadhaarNumber: string, publicKeyPem: string): Promise<string> {
        const publicKey = await this.importPublicKey(publicKeyPem);
        const encoder = new TextEncoder();
        const data = encoder.encode(aadhaarNumber);
    
        // ✅ Fix: Remove the `hash` property here (it's already set during key import)
        const encryptedBuffer = await crypto.subtle.encrypt(
          { name: 'RSA-OAEP' }, // Only specify the algorithm name
          publicKey,
          data
        );
    
        return this.arrayBufferToBase64(encryptedBuffer);
      }

      private async importPublicKey(pem: string): Promise<CryptoKey> {
        const pemContents = pem.replace(/-{5}(BEGIN|END) PUBLIC KEY-{5}/g, '').trim();
        const binaryDer = this.base64ToArrayBuffer(pemContents);
    
        // Define the `hash` when importing the key (not during encryption)
        return crypto.subtle.importKey(
          'spki',
          binaryDer,
          { 
            name: 'RSA-OAEP', 
            hash: { name: 'SHA-1' } // Hash specified here for key algorithm
          },
          true,
          ['encrypt']
        );
      }

  private base64ToArrayBuffer(base64: string): ArrayBuffer {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  }

  private arrayBufferToBase64(buffer: ArrayBuffer): string {
    const bytes = new Uint8Array(buffer);
    return btoa(String.fromCharCode(...bytes));
  }
  ngOnDestroy(): void {
    // Cleanup the interval when the component is destroyed
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  startTimer(): void {
    this.interval = setInterval(() => {
      if (this.timer > 0) {
        this.timer--;
      } else {
        clearInterval(this.interval); // Stop the timer when it reaches 0
      }
    }, 1000); // Update the timer every second
  }

  get formattedTime(): string {
    const minutes = Math.floor(this.timer / 60);
    const seconds = this.timer % 60;
    return `${this.formatTime(minutes)}:${this.formatTime(seconds)}`;
  }

  formatTime(time: number): string {
    return time < 10 ? `0${time}` : time.toString();
  }

  resetTimer(): void {
    this.timer = 120;
    this.startTimer();
  }
}